module.exports = __webpack_public_path__ + "img/wechat_qr.eb6b737d.png";